import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { X, Trash2, Upload, Check } from 'lucide-react';

const AdminImageLibrary = ({
  imageLibrary,
  uploading,
  fileInputRef,
  onSelectImage,
  onDeleteImage,
  onUpload,
  onClose
}) => {
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-background-paper border border-white/10 rounded-sm p-8 max-w-4xl w-full max-h-[80vh] overflow-y-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-heading text-2xl font-bold">
            IMAGE <span className="text-primary">LIBRARY</span>
          </h3>
          <div className="flex items-center gap-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => fileInputRef.current?.click()}
              disabled={uploading}
              className="border-white/20"
            >
              <Upload className="w-4 h-4 mr-2" />
              {uploading ? 'Uploading...' : 'Upload New'}
            </Button>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={onUpload}
              className="hidden"
            />
            <Button variant="ghost" onClick={onClose}>
              <X className="w-5 h-5" />
            </Button>
          </div>
        </div>

        {imageLibrary.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-neutral-400 mb-4">No images in library yet</p>
            <Button
              variant="outline"
              onClick={() => fileInputRef.current?.click()}
              className="border-white/20"
            >
              <Upload className="w-4 h-4 mr-2" />
              Upload First Image
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {imageLibrary.map((img) => (
              <div
                key={img.image_id}
                className="relative group aspect-square rounded-sm overflow-hidden border border-white/10 hover:border-primary transition-colors"
              >
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}${img.url}`}
                  alt={img.original_name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                  <Button
                    size="sm"
                    className="bg-primary hover:bg-primary-hover"
                    onClick={() => onSelectImage(img.url)}
                  >
                    <Check className="w-4 h-4" />
                  </Button>
                  <Button
                    size="sm"
                    variant="outline"
                    className="border-error text-error hover:bg-error hover:text-white"
                    onClick={() => onDeleteImage(img.image_id)}
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        <p className="text-xs text-neutral-500 mt-6 text-center">
          Click an image to select it, or use the trash icon to delete.
        </p>
      </motion.div>
    </div>
  );
};

export default AdminImageLibrary;
